import service from './request';
import { cachedRequest, primeCache, primeInFlight, paramsKey } from './cache';

// 首页聚合数据 / 认证 / 合作伙伴等均为全站低频变更数据，加缓存避免重复请求
export function getHomeData() {
  return cachedRequest('home', () => service.get('/api/front/home'));
}
export function getCertifications() {
  return cachedRequest('certifications', () => service.get('/api/front/certifications'));
}
export function getCertificationStats() {
  return cachedRequest('certifications/stats', () => service.get('/api/front/certifications/stats'));
}
export function getPartners() {
  return cachedRequest('partners', () => service.get('/api/front/partners'));
}
export function getSeoConfig() {
  return cachedRequest('seo', () => service.get('/api/front/seo'));
}

/**
 * 首页聚合接口：一次请求拿回首屏所需全部数据。
 * 关键：在聚合请求发出的同时，同步把各子缓存键指向「从聚合结果提取对应字段」的派生 Promise，
 * 这样子组件随后调用 getHomeData / getSolutionTree / getCertifications / getCases 时会复用同一请求，
 * 不会再各自单独发请求（解决 React 中子组件 effect 先于父组件执行的时机问题）。
 */
export function bootstrapHome() {
  const casesKey = 'cases?' + paramsKey({ pageNum: 1, pageSize: 3 });

  const agg = cachedRequest('home/bootstrap', () => service.get('/api/front/home/bootstrap'));

  // 各子 key 注册为派生的进行中 Promise（同步执行，渲染阶段即生效）
  primeInFlight('home', agg.then((r: any) => r?.home));
  primeInFlight('solutions/tree', agg.then((r: any) => r?.solutions ?? []));
  primeInFlight('certifications', agg.then((r: any) => r?.certifications ?? []));
  primeInFlight('certifications/stats', agg.then((r: any) => r?.certificationStats ?? []));
  primeInFlight(casesKey, agg.then((r: any) => ({ rows: r?.cases ?? [], total: (r?.cases ?? []).length })));

  // 案例详情待聚合返回后再逐条预热（供 CasesSection 懒加载 metrics 命中）
  agg.then((r: any) => {
    (r?.cases ?? []).forEach((c: any) => {
      if (c && c.id != null) primeCache('case/' + c.id, c);
    });
  }).catch(() => {});

  return agg;
}
